export const enumPermisosPractisistemas = Object.freeze({
    practisistemasRecargas: 10001,
    practisistemasPines: 10002,
    practisistemasSoat: 10003,   
    practisistemasApuestas: 10004,  
  });